import * as React from 'react';
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux';
import Base from './base';
import Text from './text';
import Zip from './zip';
import City from './city';
import State from './state';
import County from './county';
import Country from './country';
import Icon from '../../../icons';

class Address extends Base {
    constructor(props) {
        super(props);
        this.groupName = "Address";
        this.address1Identifier = "address1";
        this.address2Identifier = "address2";
        this.zipIdentifier = "zip";
        this.cityIdentifier = "city";
        this.stateIdentifier = "state";
        this.countyIdentifier = "county";
        this.countryIdentifier = "country";
        this.watermark = {"US":{"zip":"Zip", "state": "State", "county": "County"}, "CA":{"zip":"Zip", "state": "Provinces", "county": "County"}, "GR":{"zip":"Zip", "state": "Peripheries", "county": "Prefectures"}, "IN":{"zip":"Zip", "state": "State", "county": "Taluks"}, "KE":{"zip":"Zip", "state": "Mkoa", "county": "Kata"}, "GB":{"zip":"Postal Code", "state": "County", "county": "District"}};
        this.state={
         zipWM:"Zip",
         stateWM:"State",
         countyWM:"County",
         cityWM:"City"
        }
    }
    changePlaceholder=(value)=>{
        this.setState({
            zipWM:this.watermark[value].zip,
            stateWM:this.watermark[value].state,
            countyWM:this.watermark[value].county,
        })

    }

    renderOnCard() {
        return (
            <span className="address">
                <Text {...this.props} showLabel={false} returnValueForBlank={""}
                    data={this.parseCustomFileds(this.props.data, this.address1Identifier, this.groupName)}
                />
                <Text {...this.props} showLabel={false} returnValueForBlank={""} preAppendComma={true} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.address2Identifier, this.groupName)}
                />
                <br />
                <City {...this.props} showLabel={false} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.cityIdentifier, this.groupName)}
                />
                <State {...this.props} showLabel={false} preAppendComma={true} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.stateIdentifier, this.groupName)}
                />
                <Zip {...this.props} showLabel={false} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.zipIdentifier, this.groupName)}
                />
                <County {...this.props} showLabel={false} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.countyIdentifier, this.groupName)}
                />
            </span>
        )
    }
    renderOnGrid() {
        return (
            <div className="address">
                <div>
                    <Text {...this.props} showLabel={false} returnValueForBlank={""}
                        data={this.parseCustomFileds(this.props.data, this.address1Identifier, this.groupName)}
                    />
                    <Text {...this.props} showLabel={false} returnValueForBlank={""} includeSpace={true} preAppendComma={true}
                        data={this.parseCustomFileds(this.props.data, this.address2Identifier, this.groupName)}
                    />
                </div>

                <City {...this.props} showLabel={false} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.cityIdentifier, this.groupName)}
                />
                <State {...this.props} showLabel={false} preAppendComma={true} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.stateIdentifier, this.groupName)}
                />
                <Zip {...this.props} showLabel={false} preAppendComma={true} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.zipIdentifier, this.groupName)}
                />
                <County {...this.props} showLabel={false} preAppendComma={true} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.countyIdentifier, this.groupName)}
                />
            </div>
        )
    }
    renderOnDetail() {
        return (
            <li>
                <label>{this.props.data[0].FieldGroup}</label>
                <Text {...this.props} showLabel={false} returnValueForBlank={""}
                    data={this.parseCustomFileds(this.props.data, this.address1Identifier, this.groupName)}
                />
                <Text {...this.props} showLabel={false} returnValueForBlank={""} preAppendComma={true} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.address2Identifier, this.groupName)}
                />
                <City {...this.props} showLabel={false} preAppendComma={true} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.cityIdentifier, this.groupName)}
                />
                <State {...this.props} showLabel={false} preAppendComma={true} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.stateIdentifier, this.groupName)}
                />
                <Zip {...this.props} showLabel={false} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.zipIdentifier, this.groupName)}
                />
                <County {...this.props} showLabel={false} includeSpace={true}
                    data={this.parseCustomFileds(this.props.data, this.countyIdentifier, this.groupName)}
                />
            </li>
        )
    }

    renderOnCreate() {

        return (
            <div className="formGroup row-fluid">
                <label className="wth-3">{this.props.data[0].FieldGroup}{this.props.data[0].IsRequired && <sup>*</sup>}
                    <span className="quickTooltip-bottom" data-quicktooltip={this.props.data[0].Description}><Icon name="info" className="icon ml greyInfoIcon" /></span>
                </label>

                <div className="colFlex">
                    <div className="rowFlex formRow">
                        <div className="wth-6 bottomSpace">
                            <Text {...this.props} showLabel={false} returnValueForBlank={""}
                                data={this.parseCustomFileds(this.props.data, this.address1Identifier, this.groupName)}
                            />
                        </div>
                        <div className="wth-6 bottomSpace">
                            <Text {...this.props} showLabel={false} returnValueForBlank={""} preAppendComma={true} includeSpace={true}
                                data={this.parseCustomFileds(this.props.data, this.address2Identifier, this.groupName)}
                            />
                        </div>
                    </div>
                    <div className="rowFlex formRow">
                        <div className="wth-4">
                            <Zip {...this.props} showLabel={false} includeSpace={true} placeholder={this.state.zipWM}
                                data={this.parseCustomFileds(this.props.data, this.zipIdentifier, this.groupName)}
                            />
                        </div>
                        <div className="wth-4">
                            <State {...this.props} showLabel={false} preAppendComma={true} includeSpace={true} placeholder={this.state.stateWM}
                                data={this.parseCustomFileds(this.props.data, this.stateIdentifier, this.groupName)}
                            />
                        </div>
                        <div className="wth-4">
                            <County {...this.props} showLabel={false} includeSpace={true} placeholder={this.state.countyWM}
                                data={this.parseCustomFileds(this.props.data, this.countyIdentifier, this.groupName)}
                            />
                        </div>
                        <div className="wth-4">
                            <City {...this.props} showLabel={false} preAppendComma={true} includeSpace={true} placeholder={this.state.cityWM}
                                data={this.parseCustomFileds(this.props.data, this.cityIdentifier, this.groupName)}
                            />
                        </div>
                        <div className="wth-4">
                            <Country {...this.props} showLabel={false} includeSpace={true} changePlaceholder={(value)=>this.changePlaceholder(value)}
                                data={this.parseCustomFileds(this.props.data, this.countryIdentifier, this.groupName)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Address;